"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LoadingOverlay = require("./LoadingOverlay");
Object.keys(_LoadingOverlay).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoadingOverlay[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoadingOverlay[key];
    }
  });
});
